<template lang="pug">
.spaceContainer
  sys-bar(:backable="true" ref="sysBar")
  .content(ref="content")
    router-view
</template>

<script>
import SysBar from '@/components/SysBar'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'Footprint',
  components: {SysBar},
  props: {},
  data() {
    return {}
  },
  watch: {},
  computed: {},
  methods: {},
  mounted() { },
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint.sass"
.spaceContainer
  +full; overflow: auto
  .content
    +full
    font-family: 'Alibaba PuHuiTi 2.0'; letter-spacing: 0
    width: pxRes(414)
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(100%)
</style>
